<div [innerHTML]="inputData.html" [@fadeInOut] [@.disabled]="!inputData.shouldAnimateOnEnter"></div>
